import React, { FC, useState } from 'react';
import { ReactComponent as CancelTripIcon } from 'assets/icons/cancel-trip-modal-icon.svg';
import { toast } from 'react-toastify';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { OrderType } from 'models/order.model';
import { apiService } from 'utils/api';

interface FinishOrderModalProps {
  show: boolean;
  onClose: () => void;
  order: OrderType;
}

interface FinishOrderFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const CancelTripFooter: FC<FinishOrderFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const FinishOrderModal: FC<FinishOrderModalProps> = ({ show, onClose, order }) => {
  const [loading, setLoading] = useState(false);
  const cancelTrip = async () => {
    setLoading(true);
    try {
      await apiService.post(`kitchen/order/finish/${order.order_code}`, {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message='Updated successfully' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <BaseModal
      isOpen={show}
      title='Finish Order'
      description={`Click on Confirm button to finish order #${
        order?.order_code?.toUpperCase() ?? ''
      }`}
      titleIcon={<CancelTripIcon />}
      titleIconColor='danger'
      onRequestClose={onClose}
      footer={<CancelTripFooter loading={loading} onCancel={onClose} onConfirm={cancelTrip} />}
    />
  );
};

export default FinishOrderModal;
